// extracted by mini-css-extract-plugin
module.exports = {"mask":"spin_mask__kSNKI","spinContainer":"spin_spinContainer__273B_","text":"spin_text__2o03o"};